import React, {Component} from 'react';
import {connect} from "react-redux";
import {TYPE_TIRES} from "../../../public/journey1/definition/business";
import {EXCHANGE_TIRES, getCamelCaseType} from "../WheelsExchangeUtils";
import {Col, List, Row} from "antd";
import Constants from "../../../services/Constants";
import moment from 'moment';
import {FormattedMessage} from "react-intl";
import PlanningSlotEditModal from "./PlanningSlotEditModal";
import PlanningSlotAddModal from "./PlanningSlotAddModal";
import queryString from "query-string";
import {withRouter} from "react-router-dom";
import SwitchPlanningSlotsModal from "./SwitchPlanningSlotsModal";

class PlanningSlots extends Component {

  constructor(props) {
    super(props);
    this.state = {
      slots: [],
      selectedIndex: props.index || undefined, // save index (and not item) in order to have the selected item always up-to-date
      customer: null,
      date: null,
    }
  }

  componentDidMount(){
    if (this.state.selectedIndex){
      this.props.dispatchShowWheelsExchangeEditModal(true);
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.fetchWheelsExchangeSlots) {
      const hasError = nextProps.fetchWheelsExchangeSlots.error && nextProps.fetchWheelsExchangeSlots.error.code;
      this.setState({slots: hasError ? [] : nextProps.fetchWheelsExchangeSlots.slots})
    }
  }

  onPlanningSlotUpdate = updatedSlot => {
    const {type, day} = this.props;
    this.props.dispatchUpdateWheelsExchangeSlots({type, day, updatedSlot});
  };

  onEditModalShow = () => {
    this.props.dispatchShowWheelsExchangeEditModal(true);
  };

  onAddModalShow = () => {
    this.props.dispatchShowWheelsExchangeAddModal(true);
  };

  showSwitchModal = (customer) => {
    const {dispatchShowSwitchWheelsTiresModal} = this.props;
    this.setState({ customer });
    dispatchShowSwitchWheelsTiresModal(true);
  };

  slotIsAvailable = slot => {
    return slot.customers && slot.customers.length < slot.numberOfTeams;
  };

  onChangeSlot = (index)=>{
    this.setState({selectedIndex: index});
    this.updateUrl(index);
  }

  updateUrl = (index)=>{
    const {type, history, location} = this.props
    const parsed = queryString.parse(location.search);
    const queryParam = type === EXCHANGE_TIRES ? 'tindex' : 'windex';
    parsed[queryParam] = index;
    location.search = queryString.stringify(parsed);
    history.replace(`/tire-management?${location.search}`)

  }

  onChangeDate = (date) => {
    this.setState({date});
  }

  onSwitchSlotsUpdate = (slot) => {
    this.setState({slot});
  }

  onSave = () => {
    const {day, type, dispatchConfirmAppointment, dispatchShowSwitchWheelsTiresModal} = this.props;
    if (this.state.slot) {
      const intervention = {
        startDate: this.state.date,
        startTime: this.state.slot.startTime,
        endDate: moment(this.state.date).add(1, 'weeks').startOf('isoWeek').format(Constants.DATE_FORMAT_API),
        endTime: this.state.slot.endTime,
        duringWorkingHours: true,
        wheelsExchangeType: type,
      };
      dispatchConfirmAppointment({
        id: this.state.customer.interventionId,
        intervention,
        day
      });
      dispatchShowSwitchWheelsTiresModal(false);
    }
  }

  render() {
    const {fetchWheelsExchangeSlots: {loading}, type, day} = this.props;
    const {
      updateWheelsExchangeSlots: {showAddModal, showEditModal},
      switchTiresWheelsSlots: {showSwitchTiresModal, showSwitchWheelsModal}
    } = this.props;
    const {slots = [], selectedIndex, customer} = this.state;
    return (
      <div style={{height: '56rem', overflow: 'auto', border: '1px solid #e6e6e6'}}>
        <List className="list" dataSource={slots} loading={loading}
              renderItem={(item, index) => {
                const {customers = [], numberOfTeams, startTime, endTime} = item;
                return (
                  <List.Item style={{border: '1px solid #e6e6e6'}} onClick={() => this.onChangeSlot(index)}
                  >
                    <Row gutter={16} justify={"space-between"} style={{width:'100%'}}>

                    <Col span={4} style={{textAlign: 'center'}}>
                      <span className={`badge ${this.slotIsAvailable(item) ? 'calendar-box--available' : 'calendar-box--unavailable'}`}>{customers.length} / {numberOfTeams}</span>
                      </Col>

                    <Col span={6} style={{textAlign: 'center'}}>
                      {moment(startTime, Constants.TIME_FORMAT_API).format(Constants.TIME_FORMAT_DISPLAY)}{` - `}
                      {moment(endTime, Constants.TIME_FORMAT_API).format(Constants.TIME_FORMAT_DISPLAY)}
                    </Col>

                    <Col span={14} style={{textAlign: 'right'}}>
                      <Row justify={"space-between"}>
                        <Col span={8}>
                      <button type="primary" className="btn btn-sm btn-primary" style={{minWidth:'unset'}} onClick={this.onEditModalShow}>
                        <FormattedMessage id="action.edit" />
                      </button>
                        </Col>
                      {this.slotIsAvailable(item) &&
                        <Col span={8}>
                        <button type="primary" className="btn btn-sm btn-primary" style={{minWidth:'unset', marginLeft: '5px'}} onClick={this.onAddModalShow}>
                          <FormattedMessage id="action.add" />
                        </button>
                        </Col>
                      }
                      </Row>
                    </Col>
                    </Row>
                  </List.Item>
                )
              }}
        />
        {showEditModal && slots[selectedIndex] &&
          <PlanningSlotEditModal type={type} day={day} slot={slots[selectedIndex]} onUpdate={this.onPlanningSlotUpdate} switchDates={this.showSwitchModal} />
        }
        {showAddModal && slots[selectedIndex] &&
          <PlanningSlotAddModal type={type} day={day} slot={slots[selectedIndex]} onUpdate={this.onPlanningSlotUpdate}/>
        }
        {customer &&
          <SwitchPlanningSlotsModal
            day={day}
            type={type}
            onSave={this.onSave}
            onUpdate={this.onSwitchSlotsUpdate}
            onChangeDate={this.onChangeDate}
            visible={type === TYPE_TIRES ? showSwitchTiresModal : showSwitchWheelsModal}
          />
        }
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const camelCaseType = getCamelCaseType(ownProps.type);
  const fetchWheelsExchangeSlots = state[`fetch${camelCaseType}ExchangeSlots`];
  const updateWheelsExchangeSlots = state[`update${camelCaseType}ExchangeCustomers`];
  const switchTiresWheelsSlots = state['fetchSwitchExchangeWheelsSlots'];
  return {fetchWheelsExchangeSlots, updateWheelsExchangeSlots, switchTiresWheelsSlots}
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatchFetchWheelsExchangeSlots: request => dispatch({type: `FETCH_${ownProps.type}_EXCHANGE_SLOTS.REQUEST`, request}),
  dispatchUpdateWheelsExchangeSlots: request => dispatch({type: `SAVE_${ownProps.type}_EXCHANGE_SLOTS.REQUEST`, request}),
  dispatchShowWheelsExchangeAddModal: show => dispatch({type: `SHOW_${ownProps.type}_EXCHANGE_SLOT_ADD_MODAL`, show}),
  dispatchShowWheelsExchangeEditModal: show => dispatch({type: `SHOW_${ownProps.type}_EXCHANGE_SLOT_EDIT_MODAL`, show}),
  dispatchShowSwitchWheelsTiresModal: show => dispatch({type: `SHOW_SWITCH_${ownProps.type}_SLOTS_MODAL`, show}),
  dispatchConfirmAppointment: (body) => dispatch({type: 'SWITCH.INTERVENTION_CONFIRMATION.REQUEST', body})
});

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(PlanningSlots));



// WEBPACK FOOTER //
// ./src/components/wheelsexchange/management/PlanningSlots.js